module.exports = __webpack_public_path__ + "media/images/mute-icon-active-17a62ade0b8e0cb4b88847526d9cd3b3.svg";